"use client";
import { Box } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { Dayjs } from "dayjs";
import { useState } from "react";

interface DateRangePickerProps {
  onDateRangeChange?: (startDate: Dayjs | undefined, endDate: Dayjs | undefined) => void;
}

export default function DateRangePicker({ onDateRangeChange }: DateRangePickerProps) {
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(null);

  function onStartChange(newValue: any) {
    setStartDate(newValue);
    if (onDateRangeChange) {
      onDateRangeChange(newValue, endDate ?? undefined);
    }
  }

  function onEndChange(newValue: any) {
    setEndDate(newValue);
    if (onDateRangeChange) {
      onDateRangeChange(startDate ?? undefined, newValue);
    }
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <DatePicker
            label="Start Date"
            value={startDate}
            onChange={onStartChange}
            slotProps={{
              textField: { fullWidth: true },
            }}
          />
          ～
          <DatePicker
            label="End Date"
            value={endDate}
            onChange={onEndChange}
            slotProps={{
              textField: { fullWidth: true },
            }}
          />
        </Box>
      </Box>
    </LocalizationProvider>
  );
}
